import { render, staticRenderFns } from "./CustomerInboundsSelector.vue?vue&type=template&id=3bd306b6&scoped=true&"
import script from "./CustomerInboundsSelector.vue?vue&type=script&lang=ts&"
export * from "./CustomerInboundsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerInboundsSelector.vue?vue&type=style&index=0&id=3bd306b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd306b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VCard,VCardTitle,VDataTable,VSpacer,VTextField,VToolbar,VToolbarTitle})
